import { createAuth0Client, Auth0Client } from '@auth0/auth0-spa-js'

// This will be used later to store the client instance.
let auth0Client: Auth0Client

let initAuth0Client = async () => {
  // eslint-disable-next-line fp/no-mutation
  auth0Client = await createAuth0Client({
    domain: import.meta.env.VITE_AUTH0_DOMAIN,
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
    authorizationParams: {
      audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    },
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
  })
}

export let getTokens = async () => {
  if (!auth0Client) {
    await initAuth0Client()
  }

  let accessToken = await auth0Client.getTokenSilently()
  return { accessToken }
}
